window.addEventListener("RebuyCartUpdated", function (event) {
  let cart = event.detail.cart;
  let freeShippingCost = "0.00";
  let freeShippingCostVal = "0.00";
  let shippingCost = "5.90";
  let shippingCostVal = 590;
  let shippingCostCalculated = "0.00";
  let freeShippingThreshold = 100.0;
  let currentCurrency = window.Shopify.currency.active;
  console.log(Shopify, "currentCurrency", currentCurrency);

  let cartShippingcostEl = document.querySelector(".cart-shipping_value");
  let cartTotalPrice = Shopify.formatMoney(Number(cart.total_price));
  let cartTotalPriceInclShippingEl = document.querySelector(
    ".cart-subtotal_value"
  );

  console.log("cart total price", cartTotalPrice);
  console.log("cart total price sub string", cartTotalPrice.substring(1));

  if (Number(freeShippingThreshold) <= Number(cartTotalPrice.substring(1))) {
    shippingCostCalculated = freeShippingCostVal;
    cartShippingcostEl.innerHTML = freeShippingCost;
  } else {
    shippingCostCalculated = shippingCostVal;
    cartShippingcostEl.innerHTML = shippingCost;
  }
  let cartTotalPriceInclShipping =
    Number(cart.total_price) + Number(shippingCostCalculated);
  cartTotalPriceInclShippingEl.innerHTML = Shopify.formatMoney(
    Number(cartTotalPriceInclShipping),
    "{{amount}}"
  );

  updateDiscountSuccessTextamount();
  setTimeout(() => {
    updateRebuyCartreviews();
  }, 500);
  // updateRebuyRecosCartItemsSavings();
  updateCurrencyIcons();
  updateSalePercent(cart);
  updateTotalCartsalePercent(cart);
});

let updateDiscountSuccessTextamount = () => {
  let cartDiscountSuccessTextEls = document.querySelectorAll(
    ".rebuy-cart__flyout-item-discount-message"
  );

  cartDiscountSuccessTextEls.forEach((cartDiscountSuccessTextEl) => {
    // get the quantity of the line item
    if (
      cartDiscountSuccessTextEl.parentElement.querySelector(
        ".rebuy-cart__flyout-item-quantity-widget-label span"
      ) === null
    ) {
      return;
    }
    let lineItemQuantity = cartDiscountSuccessTextEl.parentElement
      .querySelector(".rebuy-cart__flyout-item-quantity-widget-label span")
      .nextSibling.nodeValue.toString()
      .trim();
    let cartDiscountSuccessText = cartDiscountSuccessTextEl.innerHTML;

    if (lineItemQuantity >= 4) {
      cartDiscountSuccessText = cartDiscountSuccessText.replace(/10%/g, "20%");
      cartDiscountSuccessTextEl.innerHTML = cartDiscountSuccessText;
    } else if (lineItemQuantity < 3) {
      cartDiscountSuccessText = cartDiscountSuccessText.replace(/20%/g, "10%");
      cartDiscountSuccessTextEl.innerHTML = cartDiscountSuccessText;
    }
  });
};

let updateRebuyCartreviews = () => {
  let rebuyCartReview = document.querySelector(
    ".rebuy-cart-item-review-snippet"
  );
  let cartItems = document.querySelectorAll(".rebuy-cart__flyout-item");
  cartItems.forEach((item) => {
    const cartItem = document.querySelector(`.rebuy-cart__flyout-item-info`);
    if (cartItem) {
      // append just above .rebuy-cart__flyout-item-remove element
      const removeButton = item.querySelector(
        ".rebuy-cart__flyout-item-remove"
      );
      if (removeButton) {
        // check if the rebuyCartReview element is already present
        const existingReview = item.querySelector(
          ".rebuy-cart-item-review-snippet"
        );
        if (!existingReview) {
          // clone the rebuyCartReview element so tht it can be reused for each cart item
          const clonedRebuyCartReview = rebuyCartReview.cloneNode(true);
          removeButton.insertAdjacentElement(
            "beforebegin",
            clonedRebuyCartReview
          );
        }
      }
    }
  });
};

let updateRebuyRecosCartItemsSavings = () => {
  const recoWidget = document.querySelector("#rebuy-widget-223307");
  // keep checking if the widget is loaded
  if (!recoWidget) {
    setTimeout(updateRebuyRecosCartItemsSavings, 500);
    return;
  }
  if (recoWidget) {
    const recoTitle = recoWidget.querySelector(".primary-title");
    // add a span with an arrow svg icon to the title
    if (recoTitle) {
      const arrowSvg = recoTitle.querySelector(".rebuy-recs--btn__icon");
      if (!arrowSvg) {
        const arrowMarkup = `<span class="rebuy-recs--btn__icon"><svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 0V6.79297L6.64648 4.64648L7.35352 5.35352L4 8.70703L0.646484 5.35352L1.35352 4.64648L3.5 6.79297V0H4.5Z" fill="#151515"/>
</svg>
</span>`;
        recoTitle.innerHTML += arrowMarkup;
      }
    }
    const cartItems = recoWidget.querySelectorAll(".rebuy-product-block");
    cartItems.forEach((item) => {
      const originalPrice = item.querySelector(
        ".rebuy-product-price .compare-at span:nth-child(2)"
      );
      const currentPrice = item.querySelector(
        ".rebuy-product-price .sale span:nth-child(2)"
      );

      if (originalPrice && currentPrice) {
        const existingSavingsText = item.querySelector(
          ".rebuy-product-price-savings"
        );
        if (existingSavingsText) {
          return;
        }
        let originalPriceValue = originalPrice.innerHTML.replace(
          /[^0-9.-]+/g,
          ""
        );
        // remove period from prices too
        originalPriceValue = originalPriceValue.replace(/\./g, "");
        let currentPriceValue = currentPrice.innerHTML.replace(
          /[^0-9.-]+/g,
          ""
        );
        // remove period from prices too
        currentPriceValue = currentPriceValue.replace(/\./g, "");
        // calc savings to get the discount percentage
        console.log("originalPriceValue", originalPriceValue);
        console.log("currentPriceValue", currentPriceValue);

        let savings =
          ((originalPriceValue - currentPriceValue) / originalPriceValue) * 100;
        if (Number.isNaN(savings)) {
          // remove the savings text if the calculation fails
          return;
        }
        savings = Math.round(savings);
        const savingsdiv = document.createElement("div");
        savingsdiv.classList.add("price--on-sale");
        const savingsText = document.createElement("span");
        savingsdiv.appendChild(savingsText);
        savingsText.classList.add("rebuy-product-price-savings");
        savingsText.classList.add("price-item--sale__save-tag");
        savingsText.innerHTML = `SPARE ${savings}%`;

        // append
        currentPrice.appendChild(savingsdiv);
      }
    });
    updateRebuyRecosCartItemsCtaArrow();
  }
};

let updateRebuyRecosCartItemsUnitPrice = () => {};

let updateRebuyRecosCartItemsCtaArrow = () => {
  const recoWidget = document.querySelector("#rebuy-widget-211524");
  // keep checking if the widget is loaded
  if (!recoWidget) {
    setTimeout(updateRebuyRecosCartItemsCtaArrow, 500);
    return;
  }
  if (recoWidget) {
    const cartItems = recoWidget.querySelectorAll(".rebuy-product-block");
    cartItems.forEach((item) => {
      const ctaButton = item.querySelector(".rebuy-product-actions button");
      if (ctaButton) {
        // retun if icon already exists
        const existingIcon = ctaButton.querySelector(".btn__icon");
        if (existingIcon) {
          return;
        }
        const ctabuttonMarkup = `<svg class="svg-inline--fa fa-arrow-right btn__icon" aria-hidden="true" focusable="false" data-prefix="fat" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M445.5 261.8c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-192-184c-3.2-3.1-8.3-2.9-11.3 .2s-2.9 8.3 .2 11.3L420.1 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l412.1 0L242.5 434.2c-3.2 3.1-3.3 8.1-.2 11.3s8.1 3.3 11.3 .2l192-184z"></path></svg>`;
        const ctaButtonSpan = document.createElement("span");
        ctaButtonSpan.innerHTML = ctabuttonMarkup;
        ctaButton.appendChild(ctaButtonSpan);
      }
    });
  }
};

window.addEventListener("RebuyUpsellWidgetUpdated", function (event) {
  updateRebuyRecosCartItemsSavings();
});

let updateCurrencyIcons = () => {
  let cartSubCurrency = document.querySelector(".cart-subtotal_currency");
  let cartShippingCurrency = document.querySelector(".cart-shipping_currency");
  let cartTotalCurrency = document.querySelector(".cart-total_currency");
  // get current currency
  let currentCurrency = window.Shopify.currency.active;
  if (currentCurrency === "EUR") {
    cartShippingCurrency.innerHTML = "€";
    cartSubCurrency.innerHTML = "€";
  } else {
    cartShippingCurrency.innerHTML = " CHF";
    cartSubCurrency.innerHTML = " CHF";
  }
};

window.addEventListener("RebuyCartReady", function (event) {
  // get current market
  let currentMarket = window.Shopify.country;
  // set the push-cart checkout button based on the market - span without a class name
  let pushCartCheckoutButton = document.querySelector(
    ".rebuy-cart__checkout-button span:not(.rebuy-checkout-icon)"
  );
  switch (currentMarket) {
    case "CH":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    case "DE":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kasse";
      break;
    case "AT":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    case "LI":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    default:
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kasse";
  }
});

let updateSalePercent = (cart) => {
  // get all cart items
  let cartItems = document.querySelectorAll(".rebuy-cart__flyout-item");
  
  cartItems.forEach((item) => {
    // get the final price and original price from the item in the dom
    let finalPrice = item.querySelector('.rebuy-money.sale span:not(.sr-only)');
    let originalPrice = item.querySelector('.rebuy-money.compare-at span:not(.sr-only)');

    //  convert the prices to numbers
    finalPrice = finalPrice
      ? Number(finalPrice.innerHTML.replace("€", "").replace("CHF", "").replace(",", ".").trim())
      : null;
    originalPrice = originalPrice
      ? Number(originalPrice.innerHTML.replace("€", "").replace("CHF", "").replace(",", ".").trim())
      : null;

    if (!finalPrice || !originalPrice) {
      // if no final price or original price, skip this item
      return;
    }

    if (finalPrice && originalPrice && finalPrice < originalPrice) {
      // calculate the discount percentage
      let discountPercentage =
        ((originalPrice - finalPrice) / originalPrice) * 100;
      discountPercentage = Math.round(discountPercentage);
      
      if (discountPercentage == 100) {
        // don't show discount for items 100% off
      let salePercentEl = item.querySelector(".rebuy-cart__discount-percentage");
      if (salePercentEl) {
        salePercentEl.querySelector('span').innerHTML = "";
        salePercentEl.classList.add("hidden");
      }
      return;
      }
      // update the sale percent text
      let salePercentEl = item.querySelector(".rebuy-cart__discount-percentage");
      if (salePercentEl) {
        salePercentEl.querySelector('span').innerHTML = `-${discountPercentage}%`;
        salePercentEl.classList.remove("hidden");
      }
    } else {
      // if no discount, remove the sale percent element
      let salePercentEl = item.querySelector(".rebuy-cart__discount-percentage");
      if (salePercentEl) {
        salePercentEl.querySelector('span').innerHTML = "";
        salePercentEl.classList.add("hidden");
      }
    }
  });
}

let updateTotalCartsalePercent = async (cart) => {
  // get .rebuy-cart__flyout-subtotal-compare-amount
  let totalCartCompareAt = document.querySelector(
    ".rebuy-cart__flyout-subtotal-compare-amount span:not(.sr-only)"
  );
  let totalCartFinal = document.querySelector(
    ".rebuy-cart__flyout-subtotal-final-amount span:not(.sr-only)"
  );
  let totalCartCompareAtPrice = totalCartCompareAt
    ? totalCartCompareAt.innerHTML
        .replace("€", "")
        .replace("CHF", "")
        .replace(",", ".")
        .trim()
    : 0;

  let totalCartFinalPrice = totalCartFinal
    ? totalCartFinal.innerHTML
        .replace("€", "")
        .replace("CHF", "")
        .replace(",", ".")
        .trim()
    : 0;

  let cartOriginalTotalPrice = Number(totalCartCompareAtPrice);
  let cartDiscountedTotalPrice = Number(totalCartFinalPrice);

  if (cartOriginalTotalPrice > cartDiscountedTotalPrice) {
    // calculate the discount percentage
    let discountPercentage =
      ((cartOriginalTotalPrice - cartDiscountedTotalPrice) /
        cartOriginalTotalPrice) *
      100;
    discountPercentage = Math.round(discountPercentage);
    console.log("discountPercentage", discountPercentage);
    

    if (discountPercentage == 100) {
      // don't show discount for items 100% off
      return;
    }

    // update the total sale percent text
    let totalSalePercentEl = document.querySelector(
      ".rebuy-cart__flyout-subtotal-amount_percentage-savings"
    );
    if (totalSalePercentEl) {
      totalSalePercentEl.innerHTML = `-${discountPercentage}%`;
      totalSalePercentEl.classList.remove("hidden");
    }
  } else {
    // if no discount, remove the sale percent element
    let totalSalePercentEl = document.querySelector(
      ".rebuy-cart__flyout-subtotal-amount_percentage-savings"
    );
    if (totalSalePercentEl) {
      totalSalePercentEl.innerHTML = "";
      totalSalePercentEl.classList.add("hidden");
    }
  }
};

window.addEventListener("RebuyCartClosed", function (event) {
  // remove cart-drawer-open from html tag
  document.querySelector("html").classList.remove("cart-drawer-open");
});
